import React from "react";
import Popup from "../components/Popup";
import { Typography } from "@mui/material";
import mail from "../../../../Assets/img/Login/mail.png";

const EmailSuccessful = ({ isOpen, onClose }) => {
  return (
    <>
      <Popup
        isOpen={isOpen}
        onClose={onClose}
        image={mail}
        text="Email Sent Successfully"
      >
        <Typography
          variant="subtitle1"
          sx={{ textAlign: "center", width: "360px" }}
        >
          We've sent password reset instructions to your email. Please check
          your inbox.
        </Typography>
      </Popup>
    </>
  );
};

export default EmailSuccessful;
